import React from "react";
import { Box } from '@mui/material';  
import "@fancyapps/ui/dist/fancybox/fancybox.css";   
import UserPhotosWrapper from "./UserPhotosWrapper";
   
const UserProfileLeftSidebar = ({ userData,isDeletedAccount }) => {
    const defaultAvatar =
        userData.gender?.toLowerCase() === "female"
            ? "/assets/images/user-profile/woman-avatar.svg"
            : userData.gender?.toLowerCase() === "male"
                ? "/assets/images/user-profile/man-avatar.svg"
                : "/assets/images/user-profile/default-avatar.svg";  
    return (
        <>
            <Box sx={{ position: {sm:'unset', md:'sticky', lg:'sticky'}, top: '40px', left: '0', backgroundColor: {sm:"none", md:'#FFFFFF',}, padding:{xs:'15px 15px 0 15px', sm:'0'}, borderRadius: 2, width: '100%', maxWidth: '410px',  }}>  
                <UserPhotosWrapper
                    isOnLine={userData?.isOnLine}
                    isDeletedAccount={isDeletedAccount}
                    publicPhotosProps={userData?.publicPhotos || []}
                    privatePhotosProps={userData?.privatePhotos || []}
                    profileImage={userData?.profilePicture || defaultAvatar}
                /> 
            </Box>
        </>
    );
};

export default UserProfileLeftSidebar;
